import * as React from 'react';
require('./style.css');

interface IProps {
	children?: any;
	id?: string;
}

/**
 *
 * @param props
 */
export const InfoPageTitle1 = (props: IProps) => {
	return (
		<h2 id={props.id} className="infoPageTitle1">
			{props.children}
		</h2>
	);
};
